(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shopping-improvements"]) return;
  try {
    
  function setupJmsnStickyBuy() {
    const bar = document.querySelector('.jmsn-sticky-buy');
    const original = document.querySelector('#AddToCart');
    if (!bar || !original || bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    document.body.appendChild(bar);
    const button = bar.querySelector('button');
    const sync = () => {
      button.disabled = original.disabled;
      button.textContent = original.textContent.trim();
    };
    sync();
    new MutationObserver(sync).observe(original, { attributes: true, childList: true, subtree: true });
    new IntersectionObserver(([entry]) => {
      bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }).observe(original);
    button.addEventListener('click', () => {
      if (!original.disabled) original.click();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupJmsnStickyBuy);
  else setupJmsnStickyBuy();

  } catch(e) { console.error(e); }
})();
})();
